import React from 'react';
import classnames from 'classnames';

const CheckboxV2 = ({ disabled, checked, onChange, className, id }) => {
  return (
    <span className={classnames('checkboxV2', className)}>
      <input
        className="checkbox-input"
        id={id}
        disabled={disabled}
        onChange={() => onChange && onChange(!checked)}
        checked={checked}
        type="checkbox"
      />
      <span className={`checkbox-representation${checked ? ' checked' : ''}`}>
        {checked ? (
          <svg
            style={{ transform: 'translateY(1px)' }}
            xmlns="http://www.w3.org/2000/svg"
            width="10px"
            height="9px"
            viewBox="0 0 10 9"
            version="1.1"
          >
            <g strokeWidth="1" fill="none" fillRule="evenodd" stroke="white">
              <g transform="translate(-117.000000, -162.000000)" strokeWidth="2">
                <path d="M126,163 L120,169 L118,166" />
              </g>
            </g>
          </svg>
        ) : null}
      </span>
    </span>
  );
};

export default CheckboxV2;
